import { render } from "./SocialMediaLinks.vue?vue&type=template&id=01642737"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__